import { defineMessages } from 'react-intl';

export const i18n: {
	reviewer: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reviewerFilterPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reviewerFilterLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reviewerFilterLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	reviewer: {
		id: 'search-page.filters.names.reviewer',
		defaultMessage: 'Reviewer',
		description: 'Label for filtering by reviewer',
	},
	reviewerFilterPlaceholder: {
		id: 'search-page.filter.reviewer.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for reviewer filter search input',
	},
	reviewerFilterLabelSelected: {
		id: 'search-page.filter.reviewer.label.selected',
		defaultMessage: 'Selected',
		description: 'Reviewer filter label for selected options',
	},
	reviewerFilterLabelUnselected: {
		id: 'search-page.filter.reviewer.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Reviewer filter label for suggested options',
	},
});
